var statusClassMapping = {
  'Accepted': 'label-success',
  'Expired': 'label-danger',
  'Pending': 'label-warning',
  'Declined': 'label-warning'
};
    
export default class InvitesService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    _
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this._ = _;
  }

  getInvites(inviteAccountType, requestParams) {
    return this.$http.get(this.#getBaseInviteUrl(inviteAccountType, requestParams))
      .then((r) => this.#setInviteStatus(r.data.userInvitations));
  }

  inviteUser(inviteAccountType, requestParams, invite) {
    return this.$http.post(this.#getBaseInviteUrl(inviteAccountType, requestParams), invite)
      .then(r => this.#setInviteStatus([r.data.userInvitation])[0]);
  }

  deleteInvite(inviteAccountType, requestParams) {
    return this.$http.delete(this.#getBaseInviteUrl(inviteAccountType, requestParams));
  }

  checkInviteStatus(inviteId) {
    return this.$http.get(this.#getBaseInvitationsCheckURL(inviteId));
  }

  joinInvite(inviteId, user) {
    return this.$http.post(this.#getBaseInvitationsCheckURL(inviteId) + '/join', user);
  }
  
  getSpecificUsers(accountId, accountType, affiliateOrBuyerId) {
    var url = this.#serviceUserBaseUrl(accountId, accountType, affiliateOrBuyerId) + '/Users';
    return this.$http.get(url);
  }

  #getInviteStatus(invite) {
    var status = '';
    if (!invite.isActive) {
      if (invite.acceptanceDate) {
        status = 'Accepted';
      } else if (invite.enabled) {
        status = 'Expired';
      } else {
        status = 'Declined';
      }
    } else if (!invite.acceptanceDate) {
      status = 'Pending';
    }

    return status;
  }

  #serviceUserBaseUrl(accountId, inviteAccountType, affiliateOrBuyerId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/' + inviteAccountType + '/' + affiliateOrBuyerId;
  }

  #getBaseInviteUrl(inviteAccountType, requestParams) {
    if(inviteAccountType == 'admin' || inviteAccountType == 'user' || inviteAccountType == 'allRoles'){
      return this.ngAuthSettings.apiServiceBaseUri + requestParams.accountId + '/Invitations'
        + (requestParams.inviteId ? '/' + requestParams.inviteId : '')
        + (inviteAccountType == 'allRoles' ? '?allRoles=true' : '' );
    } else {
      return this.ngAuthSettings.apiServiceBaseUri + requestParams.accountId + '/' + inviteAccountType + '/' + requestParams.inviteAccountTypeId + '/Invitations' + (requestParams.inviteId ? '/' + requestParams.inviteId : '');
    }
  }

  #getBaseInvitationsCheckURL(inviteId) {
    return this.ngAuthSettings.apiServiceBaseUri + 'Invitations/' + inviteId;
  }

  #setInviteStatus(invites) {
    return this._.map(invites, (invite) => {
      invite.status = this.#getInviteStatus(invite);
      invite.statusClass = statusClassMapping[invite.status];
      invite.name = invite.firstName + ' ' + (invite.lastName || '');
      return invite;
    });
  }
}